// You can get these ID's in the event settings within Google Ads.
// Choose to set up the tag manually and copy the last part of the conversion ID after /

export enum ConversionIdEnum {
	// General conversion ID's
	Call = 'm3YwCJnlkcIZEMeA8bUq',
	ClickEmail = '5iMMCMqIv7MaEMeA8bUq',

	// Fysio Hier conversion ID's
	BookTherapySession = 'Mnv1CJzlkcIZEMeA8bUq',

	// Fit Hier conversion ID's
	LeadFormSgtTrial = '2wzUCKOI57YaEMeA8bUq',
	LeadFormSgtIntroduction = 'TKWtCP63ut4aEMeA8bUq',
	LeadFormPgtIntroduction = 'KbmiCIG4ut4aEMeA8bUq',
	LeadFormPgtInformation = 'dl2bCIS4ut4aEMeA8bUq',
	LeadFormPtIntroduction = 'huI7CIe4ut4aEMeA8bUq',
	LeadFormPtInformation = 'pMR1CIq4ut4aEMeA8bUq',
	LeadFormUnknownIntroduction = 'f5koCPGQvt4aEMeA8bUq',

    // Werk Hier conversion ID's
    LeadFormVacancyApplication = 'nUdCCICJi5AbEMeA8bUq'
}
